"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCanvas = void 0;
function getCanvas(node, screen) {
    var existNode = node.querySelector('canvas');
    if (existNode)
        return existNode;
    if (!node.ownerDocument) {
        throw new Error('ownerDocument not set');
    }
    var canvas = node.ownerDocument.createElement('canvas');
    canvas.width = screen.width;
    canvas.height = screen.height;
    node.appendChild(canvas);
    return canvas;
}
exports.getCanvas = getCanvas;
//# sourceMappingURL=get-canvas.js.map